import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig, getDataRequirements } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig, getDataRequirements },
  catalog: {
    description: "The hosting providers serving most detected IPs or domains across platforms.",
    domain: "ip-blocking",
    visual: "Ranked list",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "list" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
